// extracted by mini-css-extract-plugin
module.exports = {"item":"Projects_item__3rc_t","flex":"Projects_flex__1RTRf","link":"Projects_link__2gP7O","name":"Projects_name__2VUe0"};